import { BILLING_PREFERENCES, CURRENCIES, Money, type Currency } from '@chukua/common';
import { Form, InputNumber, Select } from 'antd';
import { BILLING_PREFERENCE_LABELS } from '../policies/billing-preference-labels';

const BILLING_PREFERENCE_OPTIONS = BILLING_PREFERENCES.map((value) => ({ value, label: BILLING_PREFERENCE_LABELS[value] }));
const CURRENCY_OPTIONS = CURRENCIES.map((currency) => ({ value: currency, label: currency }));

/** Payment terms, billing preference and credit limit subform, shared by the create and edit customer forms. */
export function TermsAndCreditFields() {
  const currency = Form.useWatch<Currency>('creditLimitCurrency');
  const precision = Money.decimalPlaces(currency ?? 'KES');

  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="paymentTermsDays" label="Payment terms (days)" rules={[{ required: true, message: 'Enter payment terms' }]}>
          <InputNumber className="w-full" min={0} max={365} />
        </Form.Item>
        <Form.Item name="billingPreference" label="Billing preference" rules={[{ required: true }]}>
          <Select options={BILLING_PREFERENCE_OPTIONS} />
        </Form.Item>
      </div>
      <div className="grid grid-cols-[1fr_auto] gap-3">
        <Form.Item name="creditLimitAmount" label="Credit limit" rules={[{ required: true, message: 'Enter a credit limit' }]}>
          <InputNumber className="w-full" min={0} precision={precision} />
        </Form.Item>
        <Form.Item name="creditLimitCurrency" label="Currency" rules={[{ required: true }]}>
          <Select className="w-24" options={CURRENCY_OPTIONS} />
        </Form.Item>
      </div>
    </>
  );
}
